//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'

// prop types
export interface RichTextSectionProps {

    // section props
    section?: {
        marginTop?: 'small' | 'medium' | 'big' | 'none'
        marginBottom?: 'small' | 'medium' | 'big' | 'none'
    }

    content?: string
    className?: string
}

export default function RichTextSection({
    section,
    content,
    className
}: RichTextSectionProps) {
    return (
        <Section
            bgColor='white'
            className={clsx('rich-text-section', className)}
            marginTop={section?.marginTop}
            marginBottom={section?.marginBottom}
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>
                        <RichText content={content} />
                    </div>
                </div>
            </div>
        </Section>
    )
}